import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopHeader from "./TopHeader";
import { SidebarProvider, useSidebar } from "./SidebarContext";
import IncomingCallProvider from "@/components/common/IncomingCallProvider";

function LayoutInner() {
  const { collapsed } = useSidebar();
  return (
    <IncomingCallProvider>
      <div className="min-h-screen hah-page-bg">
        <Sidebar />
        <TopHeader />
        <main data-testid="main-content" className={`${collapsed ? "ml-16" : "ml-64"} pt-16 min-h-screen transition-all duration-200`}>
          <div className="px-8 py-6 max-w-[1600px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </IncomingCallProvider>
  );
}

export default function AppLayout() {
  return <SidebarProvider><LayoutInner /></SidebarProvider>;
}
